import { invertObj } from 'ramda'

export const UNAVAILABLE_STATUSES = {
  1: 'Direct booking',
  2: 'Maintenance',
  3: 'Owner holiday',
  4: 'Personal use',
  5: 'Property closed',
  6: 'Weather',
  7: 'Unforeseen circumstances',
}
export const ENQUIRE_DURATIONS = {
  12: '12',
  18: '18',
  24: '24',
}
export const BEAM_API = '/beam'
export const LOCALE_MAP = {
  'eng-GB': 'en-GB',
  'fre-FR': 'fr-FR',
  'ita-IT': 'it-IT',
  'esl-ES': 'es-ES',
}
export const LOCALE_MAP_INVERSE = invertObj(LOCALE_MAP)
export const EXTRA_TYPES = {
  DOG: 'Dogs',
  GARDEN_FURNITURE: 'Garden furniture',
  GUESTS: 'Guests',
  FIREWOOD: 'Firewood',
  TOWELS: 'Towels',
}
export const EXTRA_CHARGE_TYPES = {
  1: 'Single charge',
  2: 'Per quantity',
}
export const EXTRA_CHARGE_TYPES_KEYS = {
  CHARGE: 1,
  QUANTITY: 2,
}
export const EXTRA_DURATION_TYPES = {
  1: 'Per stay',
  2: 'Per night',
}
export const EXTRA_DURATION_TYPES_KEYS = {
  STAY: 1,
  NIGHT: 2,
}
export const EXTRA_PRICE_TYPES = {
  1: 'Amount',
  2: 'Percentage',
}
export const EXTRA_PRICE_TYPES_KEYS = {
  AMOUNT: 1,
  PERCENTAGE: 2,
}
export const RATE_LOS_DURATION_TYPES = {
  1: 'Per night',
  2: 'Per stay',
}
export const RATE_LOS_DURATION_TYPES_KEYS = {
  NIGHT: 1,
  STAY: 2,
}
